import React from 'react';

import {
  Tabs as CastlecraftTabs,
  TabList,
  Tab,
  TabPanel,
} from 'castlecraft-ui';

const Tabs = ({ tabs, activeTab, setActiveTab }) => (
  <CastlecraftTabs
    defaultValue={tabs?.[0]?.text}
    value={activeTab}
    onChange={setActiveTab}
  >
    <TabList>
      {tabs?.map((tab) => (
        <Tab key={tab?.key} value={tab.text}>
          {tab.text}
        </Tab>
      ))}
    </TabList>
    {tabs?.map((tab) => (
      <TabPanel key={tab?.key} value={tab.text}>
        {tab.content}
      </TabPanel>
    ))}
  </CastlecraftTabs>
);

export default Tabs;
